/*
 * AI1 WORLD - Prestige Wishlist (core)
 * Saves products in localStorage, scoped per logged-in customer (with a
 * one-time merge of the guest list on login). Injects heart buttons on all
 * product cards, an "Add to Wishlist" button on product pages, a header icon,
 * and renders the full wishlist page. Exposes window.AI1WL for the cart module.
 */
(function () {
  'use strict';

  var KEY = 'ai1_wishlist_v1';
  var EVT = 'ai1:wishlist:change';
  var AI1WL = window.AI1WL = window.AI1WL || {};

  function root() {
    try { if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root; }
    catch (e) {}
    return '/';
  }
  function wishlistUrl() { return root().replace(/\/+$/, '') + '/pages/wishlist'; }

  /* customer scoping */
  function customerId() {
    try { return (window.ai1Customer != null) ? String(window.ai1Customer) : null; }
    catch (e) { return null; }
  }
  function storeKey() { var c = customerId(); return c ? (KEY + '_c' + c) : KEY; }
  function mergeGuestIntoCustomer() {
    var c = customerId();
    if (!c) return;
    var guest;
    try { guest = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { guest = []; }
    if (!Array.isArray(guest) || !guest.length) return;
    var ck = storeKey(), cur;
    try { cur = JSON.parse(localStorage.getItem(ck) || '[]'); } catch (e) { cur = []; }
    if (!Array.isArray(cur)) cur = [];
    guest.forEach(function (g) { if (!cur.some(function (i) { return i.handle === g.handle; })) cur.unshift(g); });
    try { localStorage.setItem(ck, JSON.stringify(cur)); localStorage.removeItem(KEY); } catch (e) {}
  }

  /* store */
  function read() {
    try { var raw = localStorage.getItem(storeKey()); var arr = raw ? JSON.parse(raw) : []; return Array.isArray(arr) ? arr : []; }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(storeKey(), JSON.stringify(arr)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVT, { detail: { items: arr } }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function add(item) { var arr = read(); if (!arr.some(function (i) { return i.handle === item.handle; })) { arr.unshift(item); write(arr); } }
  function remove(handle) { write(read().filter(function (i) { return i.handle !== handle; })); }
  function toggle(item) { if (has(item.handle)) { remove(item.handle); return false; } add(item); return true; }
  function count() { return read().length; }

  /* helpers */
  function handleFromUrl(url) {
    if (!url) return '';
    var m = url.split('?')[0].match(/\/products\/([^\/]+)/);
    return m ? m[1] : '';
  }
  function absImg(src) { if (!src) return ''; if (src.indexOf('//') === 0) return 'https:' + src; return src; }
  /*
   * Heart icon. This is THE shared glyph: nav button, Dawn header icon, card
   * hearts and the PDP button all render it, so its geometry decides how the
   * wishlist reads on every page.
   *
   * The previous path was drawn on a different grid to the rest of the theme:
   * its ink sat at x 1.29-18.71 / y 4.54-21.00 inside the 24x24 viewBox, i.e.
   * 1.29px of margin on the left but 5.29px on the right, and it was wider
   * (17.41) than it was tall (16.46). Rendered next to the search and account
   * icons it therefore looked squat and pushed off-centre.
   *
   * This path is the one the theme's own .p-wish buttons already use. It is
   * mirrored about x=12 (3.16 and 20.84 are both 8.84 from centre) and spans
   * y 3.00-21.23, so it is optically centred and very slightly taller than
   * wide - which is what a heart should be. Keep the two in sync.
   */
  function heartSVG() {
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* toast */
  var toastTimer, toastMsg;
  function toast(msg) {
    var t = document.getElementById('ai1-wl-toast');
    var fresh = !t;
    if (fresh) {
      t = document.createElement('div'); t.id = 'ai1-wl-toast'; t.className = 'ai1-wl-toast';
      t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); t.setAttribute('aria-atomic', 'true');
      document.body.appendChild(t);
    }
    toastMsg = msg;
    /* A live region must exist before its text changes, so the first message is written one tick after creation. */
    function show() { t.textContent = toastMsg; t.classList.add('is-visible'); }
    if (fresh) setTimeout(show, 60); else show();
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  /* header icon */
  function injectHeaderIcon() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;
    var wrap = cart.parentNode;
    if (!wrap || wrap.querySelector('.ai1-wl-header')) return;
    var a = document.createElement('a');
    a.href = wishlistUrl();
    a.className = 'header__icon header__icon--wishlist ai1-wl-header link focus-inset';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<span class="svg-wrapper ai1-wl-heart">' + heartSVG() + '</span><span class="ai1-wl-badge" hidden>0</span>';
    a.addEventListener('click', function (e) {
      if (typeof AI1WL.openDrawer === 'function') { e.preventDefault(); AI1WL.openDrawer(); }
    });
    wrap.insertBefore(a, cart);
    updateBadge();
  }
  function updateBadge() {
    var n = count();
    var b = document.querySelector('.ai1-wl-header .ai1-wl-badge');
    if (b) { b.textContent = n; b.hidden = n <= 0; }
    var dc = document.querySelector('.ai1-wl-drawer__count');
    if (dc) dc.textContent = n;
    // Prestige homepage nav badge
    var nb = document.querySelector('.ai1-wl-navbadge');
    if (nb) { nb.textContent = n; nb.hidden = n <= 0; }
  }

  /* ---- Prestige homepage integration (custom .p-nav + .p-prod cards) ---- */
  function injectPrestigeNavIcon() {
    var acts = document.querySelector('.p-nav-acts');
    if (!acts || acts.querySelector('.ai1-wl-navbtn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'p-ni ai1-wl-navbtn';
    btn.setAttribute('aria-label', 'Wishlist');
    btn.innerHTML = heartSVG() + '<span class="ai1-wl-navbadge" hidden>0</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof AI1WL.openDrawer === 'function') AI1WL.openDrawer();
      else window.location.href = wishlistUrl();
    });
    var cartBtn = acts.querySelector('.p-cbtn');
    if (cartBtn) acts.insertBefore(btn, cartBtn); else acts.appendChild(btn);
    updateBadge();
  }
  function prestigeCardData(btn) {
    var card = btn.closest ? btn.closest('.p-prod') : null;
    var handle = btn.getAttribute('data-handle');
    if (!handle) return null;
    var titleEl = card ? card.querySelector('.p-prod-n') : null;
    var imgEl = card ? card.querySelector('.p-prod-img img') : null;
    var priceEl = card ? card.querySelector('.p-price') : null;
    return {
      handle: handle,
      title: titleEl ? titleEl.textContent.trim() : '',
      url: btn.getAttribute('data-url') || (root().replace(/\/+$/, '') + '/products/' + handle),
      image: imgEl ? absImg(imgEl.currentSrc || imgEl.getAttribute('src')) : '',
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  }
  function markPrestigeWishes() {
    Array.prototype.forEach.call(document.querySelectorAll('.p-wish[data-handle]'), function (b) {
      b.classList.toggle('is-active', has(b.getAttribute('data-handle')));
    });
  }

  /* card hearts */
  function extractCard(cardWrap) {
    var link = cardWrap.querySelector('.card__heading a') || cardWrap.querySelector('a.full-unstyled-link') || cardWrap.querySelector('.card__information a');
    var url = link ? link.getAttribute('href') : '';
    var handle = handleFromUrl(url);
    if (!handle) return null;
    var title = link ? link.textContent.trim() : '';
    var img = cardWrap.querySelector('.card__media img') || cardWrap.querySelector('.media img');
    var image = img ? absImg(img.currentSrc || img.getAttribute('src')) : '';
    var priceEl = cardWrap.querySelector('.price-item--sale') || cardWrap.querySelector('.price__regular .price-item') || cardWrap.querySelector('.price-item--regular');
    var price = priceEl ? priceEl.textContent.trim() : '';
    return { handle: handle, title: title, url: url, image: image, price: price };
  }
  function injectCardButtons(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper.product-card-wrapper');
    Array.prototype.forEach.call(cards, function (cardWrap) {
      if (cardWrap.querySelector('.ai1-wl-btn')) return;
      var card = cardWrap.querySelector('.card') || cardWrap;
      var data = extractCard(cardWrap);
      if (!data) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ai1-wl-btn ai1-wl-btn--card';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.setAttribute('data-handle', data.handle);
      btn.innerHTML = heartSVG();
      btn._ai1 = data;
      if (has(data.handle)) btn.classList.add('is-active');
      card.appendChild(btn);
    });
  }

  /* product page button */
  function isProductPage() {
    return document.body.classList.contains('template-product') || !!document.querySelector('.product-form__buttons') || /\/products\//.test(location.pathname);
  }
  function metaContent(p) { var m = document.querySelector('meta[property="' + p + '"]'); return m ? m.getAttribute('content') : ''; }
  function extractProduct() {
    var handle = handleFromUrl(location.pathname);
    if (!handle) return null;
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('h1.product__title') || document.querySelector('.product__title');
    var title = (titleEl && titleEl.textContent.trim()) || metaContent('og:title') || '';
    var image = metaContent('og:image');
    if (!image) {
      var mediaImg = document.querySelector('.product__media img') || document.querySelector('.product-media-container img');
      if (mediaImg) image = mediaImg.currentSrc || mediaImg.getAttribute('src') || '';
    }
    image = absImg(image);
    var priceEl = document.querySelector('.product .price-item--sale') || document.querySelector('.product .price-item--regular') || document.querySelector('.price-item--regular');
    var price = priceEl ? priceEl.textContent.trim() : '';
    return { handle: handle, title: title, url: location.pathname, image: image, price: price };
  }
  function setPdpLabel(btn, active) {
    btn.innerHTML = heartSVG() + '<span>' + (active ? 'Saved to Wishlist' : 'Add to Wishlist') + '</span>';
  }
  function injectProductButton() {
    if (!isProductPage()) return;
    var host = document.querySelector('.product-form__buttons');
    if (!host || host.querySelector('.ai1-wl-pdp')) return;
    var data = extractProduct();
    if (!data) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ai1-wl-btn ai1-wl-pdp button button--secondary';
    btn.setAttribute('data-handle', data.handle);
    btn._ai1 = data;
    var active = has(data.handle);
    setPdpLabel(btn, active);
    if (active) btn.classList.add('is-active');
    host.appendChild(btn);
  }

  /* clicks: hearts + removes */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('.ai1-wl-remove, .ai1-wl-di__remove') : null;
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-handle')); return; }
    var pw = e.target.closest ? e.target.closest('.p-wish[data-handle]') : null;
    if (pw) {
      e.preventDefault();
      e.stopPropagation();
      var pdata = prestigeCardData(pw);
      if (!pdata) return;
      var pActive = toggle(pdata);
      pw.classList.toggle('is-active', pActive);
      toast(pActive ? 'Added to your wishlist' : 'Removed from your wishlist');
      return;
    }
    var btn = e.target.closest ? e.target.closest('.ai1-wl-btn') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var data = btn._ai1 || { handle: btn.getAttribute('data-handle') };
    var nowActive = toggle(data);
    btn.classList.toggle('is-active', nowActive);
    if (btn.classList.contains('ai1-wl-pdp')) setPdpLabel(btn, nowActive);
    toast(nowActive ? 'Added to your wishlist' : 'Removed from your wishlist');
  });

  /* full wishlist page */
  function renderPage() {
    var rootEl = document.getElementById('ai1-wishlist-root');
    if (!rootEl) return;
    var grid = rootEl.querySelector('.ai1-wl-grid');
    var empty = rootEl.querySelector('.ai1-wl-empty');
    if (!grid) return;
    var items = read();

    // Toolbar (select-all + add-selected) lives just above the grid.
    var bar = rootEl.querySelector('.ai1-wl-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'ai1-wl-bar';
      bar.innerHTML =
        '<label class="ai1-wl-bar__all"><input type="checkbox" class="ai1-wl-select-all"> <span>Select all</span></label>' +
        '<button type="button" class="ai1-wl-addselected button">Add selected to bag</button>';
      grid.parentNode.insertBefore(bar, grid);
    }

    if (!items.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      bar.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    bar.hidden = false;

    grid.innerHTML = items.map(function (i) {
      var img = i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '';
      return '<article class="ai1-wl-card" data-handle="' + esc(i.handle) + '">' +
          '<label class="ai1-wl-card__check"><input type="checkbox" class="ai1-wl-check" aria-label="Select item"></label>' +
          '<button type="button" class="ai1-wl-remove" data-handle="' + esc(i.handle) + '" aria-label="Remove">&times;</button>' +
          '<a class="ai1-wl-card__media" href="' + esc(i.url) + '">' + img + '</a>' +
          '<div class="ai1-wl-card__body">' +
            '<a class="ai1-wl-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
            (i.price ? '<div class="ai1-wl-card__price">' + esc(i.price) + '</div>' : '') +
            '<div class="ai1-wl-card__variant"></div>' +
            '<button type="button" class="ai1-wl-card__add">Add to bag</button>' +
          '</div>' +
        '</article>';
    }).join('');
  }

  /* sync + observe */
  function syncAll() {
    updateBadge();
    Array.prototype.forEach.call(document.querySelectorAll('.ai1-wl-btn'), function (b) {
      var active = has(b.getAttribute('data-handle'));
      b.classList.toggle('is-active', active);
      if (b.classList.contains('ai1-wl-pdp')) setPdpLabel(b, active);
    });
    renderPage();
    injectPrestigeNavIcon();
    markPrestigeWishes();
    if (typeof AI1WL.onSync === 'function') AI1WL.onSync();
  }
  var mo;
  function observe() {
    var target = document.getElementById('MainContent') || document.body;
    if (!target || mo) return;
    var t;
    mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { injectCardButtons(); injectProductButton(); injectPrestigeNavIcon(); markPrestigeWishes(); }, 150);
    });
    mo.observe(target, { childList: true, subtree: true });
  }

  /* expose for cart module */
  AI1WL.read = read; AI1WL.write = write; AI1WL.has = has; AI1WL.remove = remove; AI1WL.count = count;
  AI1WL.root = root; AI1WL.esc = esc; AI1WL.absImg = absImg; AI1WL.wishlistUrl = wishlistUrl;
  AI1WL.toast = toast; AI1WL.updateBadge = updateBadge;

  function init() {
    mergeGuestIntoCustomer();
    injectHeaderIcon();
    injectCardButtons();
    injectProductButton();
    injectPrestigeNavIcon();
    markPrestigeWishes();
    renderPage();
    observe();
  }

  document.addEventListener(EVT, syncAll);
  window.addEventListener('storage', function (e) { if (e.key && e.key.indexOf(KEY) === 0) syncAll(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
